import 'core-js/stable';
import 'datalist-polyfill';
import 'intersection-observer';
import ReactOnRails from 'react-on-rails';
import 'regenerator-runtime/runtime';
import App from 'startup/App';

ReactOnRails.register({
    App,
});
